module.exports = __webpack_public_path__ + "static/quality-control-7ea673685ea2b1a6b82ac4865a6f4765.jpg";